const iconList = require.context('../../assets/icons', true, /\.svg$/);
export default iconList;
